<template>
  <div>
    <div class="button-bar">
      <div class="items1">
        <WDStepTitle
          :propsMode="propsMode"
          :quoteType="quoteType"
          :quoteId="quoteId"
          :status="vehicle.status"
        />
      </div>
      <div class="items2">
        <div v-if="fnIsViewQuoteButtonShow()">
          <button
            type="button"
            class="btn btn-primary btn-sm mr-2"
            @click="fnGenerateQuote('viewQuote')"
          >
            <i class="lar la-eye"></i>View quote
          </button>
        </div>

        <div v-if="fnIsSaveButtonShow()">
          <button
            type="button"
            class="btn btn-success btn-sm mr-2"
            @click="fnGenerateQuote('save')"
          >
            <i class="lar la-save"></i>Save
          </button>
        </div>
        <div v-if="fnIsShowUnlockButton()">
          <appModalUnlockMessage
            class="mr-2"
            :propsData="propsData"
            v-if="getIsLock == true"
          ></appModalUnlockMessage>

          <button
            v-if="getIsLock != true"
            class="btn btn-success btn-sm"
            data-toggle="tooltip"
            data-placement="top"
            title="Save quote"
            @click="fnSaveApplication((isSave = true))"
          >
            <i class="lar la-save"></i>Save
          </button>
        </div>

        <div v-if="propsMode == 'edit' && quoteType == 'leads'">
          <appModalLeadsMsgVSA
            class="mr-2"
            :quoteId="Number(quoteId)"
            :buttonType="'button'"
          ></appModalLeadsMsgVSA>
        </div>
        <div v-if="propsMode == 'edit' && quoteType == 'leads'">
          <appModalLeadsStatusUpdate
            v-if="loginUser.role_id"
            :row="vehicle"
            :buttonType="'button'"
            @fnRefresh="fnReload()"
          ></appModalLeadsStatusUpdate>
        </div>
      </div>
    </div>
    <div class="row" v-if="getSettingAll">
      <div class="col-12 col-md-6 col-lg-6 col-xl-3">
        <div class="mb-3 mt-3">
          <h5 class="text-info mb-0">Client Details</h5>
        </div>
        <div class="">
          <div class="form-group">
            <b-form-select
              plain
              autocomplete="off_title"
              placeholder=" "
              :options="optionTitle"
              v-model="client.title"
            ></b-form-select>
            <label class="floatingLabel" for="title">Title</label>
            <div class="invalid-feedback" v-if="getQuoteErrors['client.title']">
              {{ fnReplace(getQuoteErrors['client.title']) }}
            </div>
          </div>

          <div class="form-group">
            <input
              class="form-control"
              type="text"
              id="firstName"
              autocomplete="off_firstName"
              placeholder=" "
              v-model="client.firstName"
            />
            <label class="floatingLabel" for="firstName">First Name</label>
            <div
              class="invalid-feedback"
              v-if="getQuoteErrors['client.firstName']"
            >
              {{ fnReplace(getQuoteErrors['client.firstName']) }}
            </div>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              autocomplete="off_lastName"
              id="lastName"
              placeholder=" "
              v-model="client.lastName"
            />
            <label class="floatingLabel" for="lastName">Surname</label>
            <div
              class="invalid-feedback"
              v-if="getQuoteErrors['client.lastName']"
            >
              {{ fnReplace(getQuoteErrors['client.lastName']) }}
            </div>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              autocomplete="off_mobileNumber"
              id="mobileNumber"
              placeholder=" "
              v-model="client.mobileNumber"
            />
            <label class="floatingLabel" for="mobileNumber"
              >Mobile Number</label
            >
            <div
              class="invalid-feedback"
              v-if="getQuoteErrors['client.mobileNumber']"
            >
              {{ fnReplace(getQuoteErrors['client.mobileNumber']) }}
            </div>
          </div>
          <div class="form-group">
            <input
              class="form-control"
              type="text"
              id="email"
              autocomplete="off_email"
              placeholder=" "
              v-model="client.email"
            />
            <label class="floatingLabel" for="email">Email</label>
            <div class="invalid-feedback" v-if="getQuoteErrors['client.email']">
              {{ fnReplace(getQuoteErrors['client.email']) }}
            </div>
          </div>
          <div class="form-group">
            <input
              type="number"
              step="any"
              class="form-control"
              id="grossAnnualSalary"
              placeholder=" "
              autocomplete="off_grossAnnualSalary"
              v-model="client.grossAnnualSalary"
            />
            <label class="floatingLabel" for="grossAnnualSalary"
              >Gross Annual Salary ($)</label
            >
            <div
              class="invalid-feedback"
              v-if="getQuoteErrors['client.grossAnnualSalary']"
            >
              {{ fnReplace(getQuoteErrors['client.grossAnnualSalary']) }}
            </div>
          </div>
          <div class="form-group">
            <b-form-select
              plain
              autocomplete="off_payPeriod"
              placeholder=" "
              :options="getSettingAll.payPeriod"
              value-field="period"
              text-field="period"
              v-model="client.payPeriod"
            ></b-form-select>
            <label class="floatingLabel" for="payPeriod">Pay Period</label>
            <div
              class="invalid-feedback"
              v-if="getQuoteErrors['client.payPeriod']"
            >
              {{ fnReplace(getQuoteErrors['client.payPeriod']) }}
            </div>
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              id="employerName"
              placeholder=" "
              autocomplete="off_employerName"
              v-model="employment.employerName"
            />
            <label class="floatingLabel" for="employerName"
              >Employer Name</label
            >
            <div
              class="invalid-feedback"
              v-if="getQuoteErrors['employment.employerName']"
            >
              {{ fnReplace(getQuoteErrors['employment.employerName']) }}
            </div>
          </div>
          <div class="form-group">
            <b-form-select
              plain
              :options="getSettingAll.salaryPackagingProvider"
              value-field="id"
              text-field="name"
              placeholder=" "
              autocomplete="off_salaryPackagingProviderId"
              v-model="vehicle.salaryPackagingProviderId"
            ></b-form-select>
            <label class="floatingLabel" for="salaryPackagingProviderId"
              >Salary Packaging Provider</label
            >
            <div
              class="invalid-feedback"
              v-if="getQuoteErrors['vehicle.salaryPackagingProviderId']"
            >
              {{
                fnReplace(getQuoteErrors['vehicle.salaryPackagingProviderId'])
              }}
            </div>
          </div>

          <div
            class="form-group"
            v-if="loginUser.role_id == 1 || loginUser.role_id == 2"
          >
            <b-form-select
              plain
              :options="getFinancierDropdownList"
              value-field="id"
              text-field="name"
              placeholder=" "
              autocomplete="off_salaryPackagingProviderId"
              v-model="lookupValues.financierId"
            ></b-form-select>
            <label class="floatingLabel" for="Financier">Financier</label>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-6 col-xl-3">
        <div class="mb-3 mt-3">
          <h5 class="text-info mb-0">Vehicle Details</h5>
        </div>
        <div class="form-group">
          <b-form-select
            plain
            :options="optionVCondition"
            placeholder=" "
            autocomplete="off_vehicleCondition"
            v-model="vehicle.vehicleCondition"
          ></b-form-select>
          <label class="floatingLabel" for="vehicleCondition"
            >Vehicle Condition</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.vehicleCondition']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.vehicleCondition']) }}
          </div>
        </div>
        <div class="form-group" v-if="vehicle.vehicleCondition !== 'N'">
          <input
            type="number"
            step="any"
            class="form-control"
            id="odometerReading"
            placeholder=" "
            autocomplete="off_odometerReading"
            v-model="vehicle.odometerReading"
          />
          <label class="floatingLabel" for="odometerReading"
            >Odometer Reading</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.odometerReading']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.odometerReading']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="number"
            class="form-control"
            id="year"
            placeholder=" "
            autocomplete="off_year"
            v-model="vehicle.year"
          />
          <label class="floatingLabel" for="year">Year</label>
          <div class="invalid-feedback" v-if="getQuoteErrors['vehicle.year']">
            {{ fnReplace(getQuoteErrors['vehicle.year']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="make"
            placeholder=" "
            autocomplete="off_make"
            v-model="vehicle.make"
          />
          <label class="floatingLabel" for="make">Make</label>
          <div class="invalid-feedback" v-if="getQuoteErrors['vehicle.make']">
            {{ fnReplace(getQuoteErrors['vehicle.make']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="model"
            placeholder=" "
            autocomplete="off_model"
            v-model="vehicle.model"
          />
          <label class="floatingLabel" for="model">Model</label>
          <div class="invalid-feedback" v-if="getQuoteErrors['vehicle.model']">
            {{ fnReplace(getQuoteErrors['vehicle.model']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="variant"
            placeholder=" "
            autocomplete="off_variant"
            v-model="vehicle.variant"
          />
          <label class="floatingLabel" for="variant">Variant</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.variant']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.variant']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="bodyType"
            placeholder=" "
            autocomplete="off_bodyType"
            v-model="vehicle.bodyType"
          />
          <label class="floatingLabel" for="bodyType">Body Type</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.bodyType']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.bodyType']) }}
          </div>
        </div>
        <div class="form-group">
          <b-form-select
            plain
            :options="getSettingAll.vehicleCategory"
            value-field="id"
            text-field="category"
            placeholder=" "
            autocomplete="off_vehicleCategory"
            v-model="vehicle.vehicleCategoryId"
            @change="fnGetFuelType()"
          ></b-form-select>
          <label class="floatingLabel" for="vehicleCategory"
            >Vehicle Category</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.vehicleCategoryId']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.vehicleCategoryId']) }}
          </div>
        </div>
        <div class="form-group">
          <b-form-select
            plain
            :options="getSettingAll.transmission"
            value-field="id"
            text-field="transmission"
            placeholder=" "
            autocomplete="off_transmission"
            v-model="vehicle.transmissionId"
          ></b-form-select>
          <label class="floatingLabel" for="transmission">Transmission</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.transmissionId']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.transmissionId']) }}
          </div>
        </div>
        <div class="form-group" v-if="vehicle.vehicleCategoryId != 11">
          <b-form-select
            plain
            :options="getSettingAll.fuelType"
            value-field="id"
            text-field="fueltype"
            placeholder=" "
            autocomplete="off_fuelType"
            v-model="vehicle.fuelTypeId"
          ></b-form-select>
          <label class="floatingLabel" for="fuelType">Fuel Type</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.fuelTypeId']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.fuelTypeId']) }}
          </div>
        </div>
        <div class="form-group" v-if="vehicle.vehicleCategoryId == 11">
          <b-form-select
            plain
            :options="optionFuelType"
            value-field="value"
            text-field="text"
            placeholder=" "
            autocomplete="off_fuelType"
            v-model="vehicle.fuelTypeId"
          ></b-form-select>
          <label class="floatingLabel" for="fuelType">Fuel Type</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.fuelTypeId']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.fuelTypeId']) }}
          </div>
        </div>

        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="colour"
            placeholder=" "
            autocomplete="off_colour"
            v-model="vehicle.colour"
          />
          <label class="floatingLabel" for="colour">Colour</label>
          <div class="invalid-feedback" v-if="getQuoteErrors['vehicle.colour']">
            {{ fnReplace(getQuoteErrors['vehicle.colour']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="accessories"
            placeholder=" "
            autocomplete="off_accessories"
            v-model="vehicle.accessories"
          />
          <label class="floatingLabel" for="accessories">Accessories</label>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-6 col-xl-3">
        <div class="mb-3 mt-3">
          <h5 class="text-info mb-0">Lease Details</h5>
        </div>
        <div class="form-group">
          <b-form-select
            plain
            :options="getSettingAll.businessUsePercentage"
            value-field="percentage"
            text-field="percentage"
            placeholder=" "
            autocomplete="off_businessUsePercentage"
            v-model="vehicle.businessUsePercentage"
          ></b-form-select>
          <label class="floatingLabel" for="busuinessUsePercentage"
            >Business use Percentage</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.businessUsePercentage']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.businessUsePercentage']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="number"
            class="form-control"
            id="annualKms"
            placeholder=" "
            autocomplete="off_annualKms"
            v-model="vehicle.annualKms"
          />
          <label class="floatingLabel" for="annualKms">Annual Km's</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.annualKms']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.annualKms']) }}
          </div>
        </div>
        <div class="form-group">
          <b-form-select
            plain
            :options="getSettingAll.leaseTerm"
            value-field="term"
            text-field="term"
            placeholder=" "
            autocomplete="off_term"
            v-model="vehicle.term"
          ></b-form-select>
          <label class="floatingLabel" for="leaseTerm">Lease Term</label>
          <div class="invalid-feedback" v-if="getQuoteErrors['vehicle.term']">
            {{ fnReplace(getQuoteErrors['vehicle.term']) }}
          </div>
        </div>
        <div class="form-group">
          <b-form-checkbox
            id="noFinanceInsurance"
            v-model="vehicle.noFinanceInsurance"
            name="noFinanceInsurance"
            value="1"
            unchecked-value="0"
          >
            Don't Finance Insurance
          </b-form-checkbox>
        </div>

        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="comprehensiveInsurer"
            placeholder=" "
            autocomplete="off_comprehensiveInsurer"
            v-model="vehicle.comprehensiveInsurer"
          />
          <label class="floatingLabel" for="comprehensiveInsurer"
            >Comprehensive Insurer</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.comprehensiveInsurer']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.comprehensiveInsurer']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="number"
            step="any"
            class="form-control"
            id="comprehensiveInsurancePremium"
            placeholder=" "
            autocomplete="off_comprehensiveInsurancePremium"
            v-model="vehicle.comprehensiveInsurancePremium"
          />
          <label class="floatingLabel" for="comprehensiveInsurancePremium"
            >Comprehensive Insurance Premium ($)</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.comprehensiveInsurancePremium']"
          >
            {{
              fnReplace(getQuoteErrors['vehicle.comprehensiveInsurancePremium'])
            }}
          </div>
        </div>

        <div class="form-group">
          <input
            type="text"
            step="any"
            class="form-control"
            id="stampDuty"
            placeholder=" "
            autocomplete="off_stampDuty"
            v-model="vehicle.stampDuty"
          />
          <label class="floatingLabel" for="stampDuty"
            >Stamp Duty & Plate fees ($)</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.stampDuty']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.stampDuty']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="number"
            step="any"
            class="form-control"
            id="registration"
            placeholder=" "
            autocomplete="off_registration"
            v-model="vehicle.registration"
          />
          <label class="floatingLabel" for="registration"
            >Registration, CTP etc.. ($)</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.registration']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.registration']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="number"
            step="any"
            class="form-control"
            id="gstOnAssetActual"
            placeholder=" "
            autocomplete="off_gstOnAssetActual"
            v-model="vehicle.gstOnAssetActual"
          />
          <label class="floatingLabel" for="gstOnAssetActual">GST ($)</label>
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.gstOnAssetActual']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.gstOnAssetActual']) }}
          </div>
        </div>
        <div class="form-group">
          <input
            type="number"
            step="any"
            class="form-control"
            id="totalDriveAwayCost"
            placeholder=" "
            autocomplete="off_totalDriveAwayCost"
            v-model="vehicle.totalDriveAwayCost"
          />
          <label class="floatingLabel" for="totalDriveAwayCost"
            >Total Drive Away Cost ($)</label
          >
          <div
            class="invalid-feedback"
            v-if="getQuoteErrors['vehicle.totalDriveAwayCost']"
          >
            {{ fnReplace(getQuoteErrors['vehicle.totalDriveAwayCost']) }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-6 col-xl-3">
        <div class="mb-3 mt-3">
          <h5 class="text-info mb-0">Options</h5>
        </div>

        <div class="row mb-2">
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <span v-if="getLookupValuesAll" class="badge bg-amended">{{
              getLookupValuesAll.interest
            }}</span>
          </div>
        </div>

        <div class="row" v-if="propsMode == 'new' && getUserById">
          <div class="col-12 mt-3">
            <div class="form-group">
              <b-form-select
                plain
                :options="getDealersWhichBelongsToUser"
                value-field="id"
                text-field="name"
                placeholder=" "
                autocomplete="off_term"
                v-model="vehicle.dealerId"
                @change="fnDealerChange(vehicle.dealerId)"
              ></b-form-select>
              <label class="floatingLabel" for="leaseTerm">Select Dealer</label>
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['vehicle.dealerId']"
              >
                {{ fnReplace(getQuoteErrors['vehicle.dealerId']) }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="row"
          v-if="Object.hasOwn(dealerInfo, 'name') && propsMode == 'edit'"
        >
          <div class="col-12">
            <appWDDealer
              :roleName="'Dealer'"
              :roleInfo="dealerInfo"
            ></appWDDealer>
          </div>
        </div>

        <div
          class="row"
          v-if="
            Object.hasOwn(referralPartnersInfo, 'name') &&
            propsMode == 'edit' &&
            this.leadSource == 'RDL'
          "
        >
          <div class="col-12">
            <appWDDealer
              :roleName="'Referral partner'"
              :roleInfo="referralPartnersInfo"
            ></appWDDealer>
          </div>
        </div>

        <div
          class="row"
          v-if="Object.hasOwn(referDealerInfo, 'name') && propsMode == 'edit'"
        >
          <div class="col-12">
            <appWDDealer
              :roleName="'Refer Dealer'"
              :roleInfo="referDealerInfo"
            ></appWDDealer>
          </div>
        </div>

        <div
          class="row"
          v-if="this.quoteType == 'leads' && this.leadSource != 'RDL'"
        >
          <div class="col-12">
            <div class="">
              <div class="form-group">
                <b-form-select
                  plain
                  autocomplete="off_referralPartnerId"
                  placeholder=" "
                  :options="fnGetReferralPartner()"
                  value-field="id"
                  text-field="name"
                  v-model="vehicle.referralPartnerId"
                ></b-form-select>
                <label class="floatingLabel" for="referralPartnerId"
                  >Referring partner</label
                >
                <div
                  class="invalid-feedback"
                  v-if="errors['vehicle.referralPartnerId']"
                >
                  {{ fnReplace(errors['vehicle.referralPartnerId']) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div
          class="row"
          v-if="propsMode == 'new' && getUserById && this.leadSource == 'RDL'"
        >
          <div class="col-12 mt-3">
            <div class="form-group">
              <b-form-select
                plain
                :options="getDealersWhichBelongsToUser"
                value-field="id"
                text-field="name"
                placeholder=" "
                autocomplete="off_term"
                v-model="vehicle.referDealerId"
              ></b-form-select>
              <label class="floatingLabel" for="leaseTerm"
                >Select Refer Dealer</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['vehicle.dealerId']"
              >
                {{ fnReplace(getQuoteErrors['vehicle.dealerId']) }}
              </div>
            </div>
          </div>
        </div> -->

        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <b-form-checkbox
              id="needToCompeteYesNo"
              v-model="vehicle.needToCompeteYesNo"
              name="needToCompeteYesNo"
              value="Yes"
              unchecked-value="No"
            >
              Compete
            </b-form-checkbox>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div
              class="form-group"
              v-show="vehicle.needToCompeteYesNo == 'Yes'"
            >
              <b-form-select
                plain
                :options="selectedDealerBrokerageOptions"
                placeholder=" "
                autocomplete="off_dealerBrokerage"
                v-model="vehicle.dealerBrokerage"
              ></b-form-select>
              <label class="floatingLabel" for="dealerBrokerage"
                >Brokerage Rate</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['vehicle.dealerBrokerage']"
              >
                {{ fnReplace(getQuoteErrors['vehicle.dealerBrokerage']) }}
              </div>
            </div>

            <div
              class="form-group"
              v-if="
                vehicle.needToCompeteYesNo == 'Yes' &&
                propsMode == 'edit' &&
                (loginUser.role_id == 1 ||
                  loginUser.role_id == 2 ||
                  loginUser.role_id == 3)
              "
            >
              <b-form-select
                plain
                :options="selectedVSABrokerageOptions"
                placeholder=" "
                autocomplete="off_brokerageVSA"
                v-model="lookupValues.brokerageVSA"
              ></b-form-select>
              <label class="floatingLabel" for="brokerageVSA"
                >VSA Brokerage Rate</label
              >
              <div
                class="invalid-feedback"
                v-if="getQuoteErrors['lookupValues.brokerageVSA']"
              >
                {{ fnReplace(getQuoteErrors['lookupValues.brokerageVSA']) }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <b-form-checkbox
              id="chanageBudgetsYesNo"
              v-model="vehicle.chanageBudgetsYesNo"
              name="chanageBudgetsYesNo"
              value="M"
              unchecked-value="A"
            >
              Set Manual Budgets
            </b-form-checkbox>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-8 col-12">
            <div v-if="vehicle.chanageBudgetsYesNo == 'M'">
              <div class="form-group">
                <input
                  class="form-control"
                  type="number"
                  id="fuelBudget"
                  autocomplete="off_fuelBudget"
                  placeholder=" "
                  v-model="vehicle.fuelBudget"
                />
                <label class="floatingLabel" for="fuelBudget"
                  >Fuel Budget ($)</label
                >
                <div
                  class="invalid-feedback"
                  v-if="getQuoteErrors['vehicle.fuelBudget']"
                >
                  {{ fnReplace(getQuoteErrors['vehicle.fuelBudget']) }}
                </div>
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  type="number"
                  id="serviceBudget"
                  autocomplete="off_serviceBudget"
                  placeholder=" "
                  v-model="vehicle.serviceBudget"
                />
                <label class="floatingLabel" for="serviceBudget"
                  >Service Budget</label
                >
                <div
                  class="invalid-feedback"
                  v-if="getQuoteErrors['vehicle.serviceBudget']"
                >
                  {{ fnReplace(getQuoteErrors['vehicle.serviceBudget']) }}
                </div>
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  type="number"
                  id="tyreBudget"
                  autocomplete="off_tyreBudget"
                  placeholder=" "
                  v-model="vehicle.tyreBudget"
                />
                <label class="floatingLabel" for="tyreBudget"
                  >Tyre Budget</label
                >
                <div
                  class="invalid-feedback"
                  v-if="getQuoteErrors['vehicle.tyreBudget']"
                >
                  {{ fnReplace(getQuoteErrors['vehicle.tyreBudget']) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalQuoteSubmitConfirm
      ref="modalQuoteSubmitConfirm"
      :propsData="propsData"
      :quoteType="quoteType"
    ></ModalQuoteSubmitConfirm>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../services/message.service'
import * as quoteService from '../../services/quote.service'
import * as leadsService from '../../services/leads.service'
import * as authService from '../../services/auth.service'
import { optionTitle, optionVCondition } from '../../services/data.service'
import appModalQuoteEmailOptions from '../../components/quote/ModalQuoteEmailOptions.vue'
import appModalUnlockMessage from '../../components/quote/ModalUnlockMessage.vue'
import appWDDealer from '../../components/wd/WDDealer.vue'
import appModalLeadsStatusUpdate from '../../components/admin/ModalLeadsStatusUpdate.vue'
import appModalLeadsMsgVSA from '../../components/leads/ModalLeadsMsgVSA.vue'
import WDStepTitle from '../../components/wd/WDStepTitle.vue'
import ModalQuoteSubmitConfirm from '../../components/quote/ModalQuoteSubmitConfirm.vue'

export default {
  name: 'quoteStep1',
  props: {
    propsMode: {
      type: String,
      required: true
    },
    propsData: {
      type: Object,
      required: false
    },
    quoteType: {
      type: String,
      required: true
    },
    leadSource: {
      type: String,
      required: false
    }
  },
  components: {
    appModalQuoteEmailOptions,
    appModalUnlockMessage,
    appWDDealer,
    appModalLeadsStatusUpdate,
    appModalLeadsMsgVSA,
    WDStepTitle,
    ModalQuoteSubmitConfirm
  },

  data() {
    return {
      quoteId: this.$route.params.quoteId,
      submit_mode: 'save',
      errors: {},
      settingAll: {},
      loginUser: {},
      step: 1,
      viewNewQuote: false,
      checkUnlocked: false,
      dealerInfo: {},
      referralPartnersInfo: {},
      referDealerInfo: {},
      selectedDealerBrokerageOptions: [],
      selectedVSABrokerageOptions: [],
      isOpenQuote: false,
      isSave: false,
      // client_vehicle_details
      vehicle: {
        id: '',
        clientId: '',
        dealerId: '',
        referralPartnerId: '',
        referDealerId: '',
        leadSource: this.leadSource || '',
        salaryPackagingProviderId: 1,
        salaryPackagingProviderFee: '',
        vehicleCondition: 'N',
        odometerReading: '',
        year: '',
        make: '',
        model: '',
        variant: '',
        bodyType: '',
        vehicleCategoryId: 1,
        fuelFlatRate: '',
        fuelCostPerKM: '',
        tyresCostPerKM: '',
        serviceCostPerKM: '',
        transmissionId: 1,
        fuelTypeId: 1,
        colour: '',
        accessories: '',
        term: 60,
        rvRate: '',
        annualKms: '',
        noFinanceInsurance: 0,
        comprehensiveInsurer: '',
        comprehensiveInsurancePremium: '',
        businessUsePercentage: 0,
        stampDuty: 0,
        registration: '',
        gstOnAsset: '',
        gstOnAssetActual: '',
        totalDriveAwayCost: '',
        chanageBudgetsYesNo: 'A',
        fuelBudget: '',
        serviceBudget: '',
        tyreBudget: '',
        needToCompeteYesNo: 'No',
        dealerBrokerage: '',
        status: 1,
        sortOrder: 6,
        has_messages: 0,
        messages_for_vsa: 0,
        messages_for_other: 0,
        privacyConsent: 0,
        settlementDate: '',
        fa_no: '',
        edd: ''
      },
      // Client information
      client: {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobileNumber: '',
        email: '',
        grossAnnualSalary: 0,
        payPeriod: 'Weekly',
        dateOfBirth: '',
        anotherNameYesNo: 'No',
        otherFirstName: '',
        otherMiddleName: '',
        otherLastName: '',
        driversLicenceNumber: '',
        driversLicenceCardNumber: '',
        driversLicenceExpiryDate: '',
        driversLicenceState: '',
        driversLicenceType: 'Full',
        maritalStatus: 'Single',
        numberOfDependents: '',
        partnerAnnualGrossSalary: '',
        australianResidencyStatusId: 1,
        visaTypeId: '',
        citizenOfAnotherCountryYesNo: 'No',
        citizenOfAnotherCountry: '',
        hAddressUnitNumber: '',
        hAddressStreetNumber: '',
        hAddressStreetName: '',
        hAddressSuburb: '',
        hAddressState: '',
        hAddressPostcode: '',
        hAddressCountry: 'Australia',
        hAddressTimeAtYears: 0,
        hAddressTimeAtMonths: 0,
        hAddressResidenceStatus: '',
        hAddressMonthlyRentalAmount: '',
        pHAddressUnitNumber: '',
        pHAddressStreetNumber: '',
        pHAddressStreetName: '',
        pHAddressSuburb: '',
        pHAddressState: '',
        pHAddressPostcode: '',
        pHAddressCountry: 'Australia',
        pHAddressTimeAtYears: '',
        pHAddressTimeAtMonths: 0,
        postalAddressAndHomeAddressAreSameYesNo: 'Yes',
        postalAddressPOBoxNumber: '',
        postalAddressSuburb: '',
        postalAddressState: '',
        postalAddressPostcode: '',
        status: 1
      },
      //client_employment_detailsgetStepNumber
      employment: {
        quoteId: '',
        employerName: '',
        tradingName: '',
        ABNOfEmployerOnPayslip: '',
        websiteAddress: '',
        employmentStatus: '',
        occupation: '',
        employerAddressBuildingName: '',
        employerAddressUnitNumber: '',
        employerAddressStreetNumber: '',
        employerAddressStreetName: '',
        employerAddressSuburb: '',
        employerAddressState: '',
        employerAddressPostcode: '',
        employerAddressTimeAtYears: 0,
        employerAddressTimeAtMonths: 0,
        employerContactName: '',
        employerContactNumber: '',
        pEmployerName: '',
        pABNOfEmployerOnPayslip: '',
        pEmploymentStatus: '',
        pOccupation: '',
        pEmployerAddressBuildingName: '',
        pEmployerAddressUnitNumber: '',
        pEmployerAddressStreetNumber: '',
        pEmployerAddressStreetName: '',
        pEmployerAddressSuburb: '',
        pEmployerAddressState: '',
        pEmployerAddressPostcode: '',
        pEmployerAddressTimeAtYears: 0,
        pEmployerAddressTimeAtMonths: 0,
        pEmployerContactName: '',
        pEmployerContactNumber: '',
        investmentIncome: 0,
        govConvertibleIncome: 0,
        otherIncome: 0,
        noteOnOtherIncome: ''
      },
      //client_finance_details
      finance: {
        quoteId: '',
        homePropertyValve: '',
        investmentProperty: [
          {
            value: '',
            limit: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        vehicleProperty: [
          {
            value: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        otherMajorVehicles: '',
        superannuationBalance: '',
        toolsAndEquipment: '',
        sharesTrustsSMSF: '',
        cashInTheBank: '',
        homeContents: '',
        otherMajorAsset: '',
        listOtherMajorAsset: '',
        homeLoanBalance: '',
        homeLoanLimit: '',
        homeLoanLenderName: '',
        homeLoanMonthlyPayment: '',
        personalLoan: [
          {
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        creditCard: [
          {
            limit: '',
            lenderName: ''
          }
        ],
        privateSchoolFees: '',
        vehicleRunningCosts: '',
        livingExpenses: '',
        insurances: '',
        ratesPowerWater: '',
        entertainment: '',
        otherMajorMonthlyExpenses: '',
        totalMonthlyExpenses: 0
      },
      //client_application_notes
      notes: {
        applicationNotes: ''
      },
      //lookup value
      lookupValues: {
        FBTRate: '0',
        GAPInsurance: '0',
        GAPInsuranceVSA: '0',
        GST: '0',
        GSTLimit: '0',
        GSTMaxOnAssets: '0',
        PPSRFee: '0',
        brokerage: '0',
        brokerageVSADefault: '0',
        brokerageVSA: '0.05',
        id: -1,
        financierId: -1,
        interest: '0',
        leaseAdminFee: '0',
        leaseAdminFeeVSA: '0',
        mcLeaseFee: '0',
        medicare: '0',
        quoteId: -1,
        registration: '0',
        tyreReplaceFreq: '0',
        tyreWheelInsurance: '0'
      },
      optionTitle: optionTitle,
      optionVCondition: optionVCondition,
      optionFuelType: [{ text: 'Electricity', value: '4' }]
    }
  },
  computed: {
    ...mapGetters([
      'getSettingAll',
      'getStepNumber',
      'getQuoteSteps',
      'getSaveApplication',
      'getIsLock',
      'getUserById',
      'getLookupValuesAll',
      'getQuoteErrors',
      'getQuoteSingle',
      'getReferralPartnerDropdownList',
      'getFinancierDropdownList'
    ]),
    getDealersWhichBelongsToUser() {
      let arr = this.getUserById?.dealers

      if (arr == undefined) {
        return
      }

      /**
       * If new quote create by dealer staff, VSA Admin or VSA Staff, or BDM, dealers which blogs to them will list on the dropdown liat
       * If the User has only one dealership and as a new quote
       */
      if (this.propsMode == 'new') {
        if (arr.length == 1) {
          this.vehicle.dealerId = arr[0].id
          this.vehicle.dealerBrokerage = arr[0]?.dealerBrokerage

          this.fnDealerBrokerageOptions(arr[0]?.dealerBrokerage)
          return arr
        }

        return arr
      }
    },

    getReferralPartnersWhichBelongsToUser() {
      let arr = this.getUserById.referral_partners

      if (arr == undefined) {
        return
      }

      if (arr && arr.length == 1) {
        this.vehicle.referralPartnerId = arr[0].id
      }
      return arr
    },

    /**
     * Only Dealers
     */
    isDealer() {
      const { role_id } = this.loginUser
      if (role_id == '4') {
        return true
      }

      return false
    },
    /**
     * All VSA Staff
     */
    isVsaStaff() {
      const { role_id } = this.loginUser
      if (role_id == '1' || role_id == '2' || role_id == '3') {
        return true
      }

      return false
    }
  },

  methods: {
    ...mapActions([
      'fetchStepNumber',
      'fetchQuoteSteps',
      'fetchSaveApplication',
      'fetchQuoteSingle',
      'fetchTaxTableAll',
      'fetchUserById',
      'fetchLookupValuesAll',
      'fetchQuoteErrors',
      'fetchReferralPartnerDropdownList',
      'fetchIsLock',
      'fetchFinancierDropdownList'
    ]),
    fnGenerateQuote: async function (submit_mode) {
      this.submit_mode = submit_mode
      this.viewNewQuote = true
      this.isOpenQuote = false

      if (this.propsMode == 'new' && this.submit_mode == 'save') {
        this.create()

        return
      }

      if (this.propsMode == 'new' && this.submit_mode == 'viewQuote') {
        this.create()

        return
      }

      if (
        this.propsMode == 'edit' &&
        this.getIsLock == false &&
        this.submit_mode !== 'viewQuote'
      ) {
        await this.fnSaveApplication()

        return
      }

      if (
        this.propsMode == 'edit' &&
        this.getIsLock == true &&
        this.submit_mode !== 'viewQuote'
      ) {
        await this.fnSaveApplication()

        return
      }

      if (
        this.propsMode == 'edit' &&
        this.getIsLock == false &&
        this.submit_mode == 'viewQuote'
      ) {
        await this.fnSaveApplication()

        if (this.getSaveApplication == 'success') {
          this.fnViewQuote(this.quoteId, this.quoteType)
        }

        return
      }

      if (
        this.propsMode == 'edit' &&
        this.getIsLock == true &&
        this.submit_mode == 'viewQuote'
      ) {
        this.fnViewQuote(this.quoteId, this.quoteType)

        return
      }
    },

    fnViewQuote(quoteId, quoteType) {
      if (
        quoteType == 'quote' &&
        (this.loginUser.role_id == 1 || this.loginUser.role_id == 2)
      ) {
        this.$router.push({
          name: 'admin.quoteView',
          params: { quoteId: quoteId }
        })
      }

      if (quoteType == 'quote' && this.loginUser.role_id == 3) {
        this.$router.push({
          name: 'bdm.quoteView',
          params: { quoteId: quoteId }
        })
      }

      if (quoteType == 'quote' && this.loginUser.role_id == 4) {
        this.$router.push({
          name: 'dealer.quoteView',
          params: { quoteId: quoteId }
        })
      }

      if (
        quoteType == 'leads' &&
        (this.loginUser.role_id == 1 || this.loginUser.role_id == 2)
      ) {
        this.$router.push({
          name: 'admin.leadsView',
          params: { quoteId: quoteId }
        })
      }

      if (quoteType == 'leads' && this.loginUser.role_id == 3) {
        this.$router.push({
          name: 'bdm.leadsView',
          params: { quoteId: quoteId }
        })
      }

      if (quoteType == 'leads' && this.loginUser.role_id == 4) {
        this.$router.push({
          name: 'dealer.leadsView',
          params: { quoteId: quoteId }
        })
      }

      if (quoteType == 'leads' && this.loginUser.role_id == 4) {
        this.$router.push({
          name: 'dealer.leadsView',
          params: { quoteId: quoteId }
        })
      }
    },

    /**
     * New Quote / Leads
     */
    create: async function () {
      // To clear previous error messages
      this.fetchQuoteErrors({})

      if (this.leadSource == 'RDL') {
        this.vehicle.referDealerId = this.vehicle.dealerId
      } else {
        this.vehicle.referDealerId = ''
      }

      const allData = {
        quoteType: this.quoteType,
        propsMode: this.propsMode,
        submit_mode: this.submit_mode,
        vehicle: this.vehicle,
        client: this.client,
        employment: this.employment,
        finance: this.finance,
        notes: this.notes,
        lookupValues: this.lookupValues
      }

      try {
        this.errors = {}
        let response = ''

        if (this.quoteType == 'quote') {
          response = await quoteService.add(JSON.stringify(allData))
        }

        if (this.quoteType == 'leads') {
          response = await leadsService.add(JSON.stringify(allData))
        }

        if (
          response.status == 200 &&
          this.quoteType == 'quote' &&
          this.submit_mode == 'save'
        ) {
          let quoteId = response.data.quoteData.id

          if (this.loginUser.role_id == 1 || this.loginUser.role_id == 2) {
            this.$router.push({
              name: 'admin.quoteEdit',
              params: { quoteId: quoteId }
            })
          } else if (this.loginUser.role_id == 3) {
            this.$router.push({
              name: 'bdm.quoteEdit',
              params: { quoteId: quoteId }
            })
          } else if (this.loginUser.role_id == 4) {
            this.$router.push({
              name: 'dealer.quoteEdit',
              params: { quoteId: quoteId }
            })
          }

          messageService.fnSweetAlertSuccessToast(
            'Quote - new',
            'Started new quote successfully '
          )
        }

        if (
          response.status == 200 &&
          this.quoteType == 'quote' &&
          this.submit_mode == 'viewQuote'
        ) {
          let quoteId = response.data.quoteData.id

          if (this.loginUser.role_id == 1 || this.loginUser.role_id == 2) {
            this.$router.push({
              name: 'admin.quoteView',
              params: { quoteId: quoteId }
            })
          } else if (this.loginUser.role_id == 3) {
            this.$router.push({
              name: 'bdm.quoteView',
              params: { quoteId: quoteId }
            })
          } else if (this.loginUser.role_id == 4) {
            this.$router.push({
              name: 'dealer.quoteView',
              params: { quoteId: quoteId }
            })
          }

          messageService.fnSweetAlertSuccessToast(
            'Quote - new',
            'Started new quote successfully '
          )
        }

        if (
          response.status == 200 &&
          this.quoteType == 'leads' &&
          this.submit_mode == 'save'
        ) {
          let quoteId = response.data.quoteData.id

          if (this.loginUser.role_id == 1 || this.loginUser.role_id == 2) {
            this.$router.push({
              name: 'admin.leadsEdit',
              params: { quoteId: quoteId }
            })
          } else if (this.loginUser.role_id == 3) {
            this.$router.push({
              name: 'bdm.leadsEdit',
              params: { quoteId: quoteId }
            })
          } else if (this.loginUser.role_id == 4) {
            if (this.leadSource == 'RPL' || this.leadSource == 'RCL') {
              this.$router.push({
                name: 'dealer.leadsEdit',
                params: { quoteId: quoteId }
              })
            } else if (this.leadSource == 'RDL') {
              this.$router.push({
                name: 'dealer.referLeadsList',
                params: { quoteId: quoteId }
              })
            }
          }

          messageService.fnSweetAlertSuccessToast(
            'Lead - new',
            'Started new Lead successfully '
          )
        }

        if (
          response.status == 200 &&
          this.quoteType == 'leads' &&
          this.submit_mode == 'viewQuote'
        ) {
          let quoteId = response.data.quoteData.id

          if (this.loginUser.role_id == 1 || this.loginUser.role_id == 2) {
            this.$router.push({
              name: 'admin.leadsView',
              params: { quoteId: quoteId }
            })
          } else if (this.loginUser.role_id == 3) {
            this.$router.push({
              name: 'bdm.leadsView',
              params: { quoteId: quoteId }
            })
          } else if (this.loginUser.role_id == 4) {
            if (this.leadSource == 'RPL' || this.leadSource == 'RCL') {
              this.$router.push({
                name: 'dealer.leadsView',
                params: { quoteId: quoteId }
              })
            } else if (this.leadSource == 'RDL') {
              this.$router.push({
                name: 'dealer.referLeadsView',
                params: { quoteId: quoteId }
              })
            }
          }

          messageService.fnSweetAlertSuccessToast(
            'Lead - new',
            'Started new Lead successfully '
          )
        }
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            this.fetchQuoteErrors(this.errors)
            messageService.fnSweetAlertErrorToast(
              'Quote - new',
              'Mandatory fields are required'
            )
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Quote - new',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Quote - new',
              'Something wrong'
            )
            break
        }
      }
    },

    fnSaveApplication: async function () {
      const allData = {
        quoteType: this.quoteType,
        propsMode: this.propsMode,
        leadSource: this.leadSource,
        submit_mode: this.submit_mode,
        quoteId: this.quoteId,
        vehicle: this.vehicle,
        client: this.client,
        employment: this.employment,
        finance: this.finance,
        lookupValues: this.lookupValues,
        notes: this.notes
      }

      await this.fetchSaveApplication(allData)
      await this.fetchQuoteSingle({
        id: this.quoteId,
        quoteType: this.quoteType
      })
      this.fnCallModalQuoteSubmitConfirm()
    },
    fnGetFuelType() {
      if (this.vehicle.vehicleCategoryId == 11) {
        this.vehicle.fuelTypeId = 4
      }
    },
    fnReplace(str) {
      const newString = str.toString().replace('[', '').replace(']', '')

      return newString
    },
    /**
     * To Show Processed Application button
     */
    fnIsShowProceedToApplication() {
      let status = false
      if (this.propsMode == 'new') {
        status = true
      }

      if (this.propsMode == 'edit') {
        if (
          this.propsData.status == 1 ||
          this.propsData.status == 7 ||
          this.propsData.status == 8
        ) {
          status = true
        }

        if (this.getIsLock != true) {
          status = true
        }
      }

      return status
    },
    /**
     * To Show Unlock button
     */
    fnIsShowUnlockButton() {
      let status = false
      if (this.propsMode == 'edit') {
        if (
          this.propsData.status != 1 &&
          this.propsData.status != 7 &&
          this.propsData.status != 8 &&
          this.quoteType == 'quote'
        ) {
          status = true
        }

        if (
          this.propsData.status != 21 &&
          this.propsData.status != 22 &&
          this.propsData.status != 24 &&
          this.propsData.status != 25 &&
          this.propsData.status != 26 &&
          this.quoteType == 'leads'
        ) {
          status = true
        }
      }
      return status
    },

    /**
     * Show Save button
     *
     */
    fnIsSaveButtonShow() {
      let status = false

      if (this.propsMode == 'new') {
        return true
      }

      if (
        this.propsMode == 'edit' &&
        this.propsData &&
        (this.propsData.status == 1 ||
          this.propsData.status == 7 ||
          this.propsData.status == 8 ||
          this.propsData.status == 21 ||
          this.propsData.status == 22 ||
          this.propsData.status == 24 ||
          this.propsData.status == 25 ||
          this.propsData.status == 26)
      ) {
        return true
      }

      return status
    },

    /**
     * Show ViewQuote button
     */
    fnIsViewQuoteButtonShow() {
      let status = false

      if (this.propsMode == 'new') {
        return true
      }

      if (this.propsMode == 'edit') {
        return true
      }

      return status
    },

    /**
     * Load Referral Partner
     * if Admin/Admin staff, BDM whole Referral Partner
     * if Dealer, assigned Referral Partner which belongs to him
     */
    fnGetReferralPartner() {
      if (
        this.loginUser.role_id == 1 ||
        this.loginUser.role_id == 2 ||
        this.loginUser.role_id == 3
      ) {
        return this.getReferralPartnerDropdownList
      }

      return this.getReferralPartnersWhichBelongsToUser
    },

    fnCheckIsLocked(status) {
      if (
        status == 2 ||
        status == 3 ||
        status == 4 ||
        status == 5 ||
        status == 6 ||
        status == 9 ||
        status == 10 ||
        status == 11 ||
        status == 12 ||
        status == 13 ||
        status == 14 ||
        status == 23
      ) {
        this.fetchIsLock(true)
      } else {
        this.fetchIsLock(false)
      }
    },
    /**
     * To get maximum dealer commission which assign  each dealer on create
     * Each dealer user can work on at least one dealership or multiple dealer ship
     * So, we need to find selected dealer maximum dealer commission
     */
    fnDealerChange(selectedDealerId) {
      const arr = this.getUserById?.dealers

      if (arr == undefined) {
        return
      }

      const dealer = arr.find((item) => item.id == selectedDealerId)
      const { id, dealerBrokerage } = dealer

      if (arr.length > 1 && this.propsMode == 'new') {
        this.vehicle.dealerId = id
        this.vehicle.dealerBrokerage = dealerBrokerage
        this.fnDealerBrokerageOptions(dealerBrokerage)

        return dealer
      }

      // const dealerBrokerageQuote = this.vehicle.dealerBrokerage

      this.fnDealerBrokerageOptions(dealerBrokerage)

      // if (dealerBrokerageQuote > dealerBrokerage) {
      //   this.fnDealerBrokerageOptions(dealerBrokerageQuote)
      // } else {
      //   this.fnDealerBrokerageOptions(dealerBrokerage)
      // }

      return dealer
    },

    /**
     * After getting maximum dealer brokerage, generate brokerage options below to Maximum number
     * @param {*} maxBrokerage
     */
    fnDealerBrokerageOptions(maxBrokerage) {
      let length = 0
      let options = []

      if (maxBrokerage) {
        length = Number(maxBrokerage) * 100
      }

      for (let i = 0; i < length + 1; i++) {
        options.push({
          text: i,
          value: (i / 100).toFixed(2)
        })
      }

      this.selectedDealerBrokerageOptions = options

      return options
    },
    /**
     * After getting maximum vsa brokerage, generate brokerage options below to Maximum number
     * Here allow VSA Admin to go 0 to 0.1
     * @param {*} maxBrokerage = 0.1
     */
    fnVSABrokerageOptions(maxBrokerage) {
      let length = 0
      let options = []

      if (maxBrokerage) {
        length = Number(maxBrokerage) * 100
      }

      for (let i = 0; i < length + 1; i++) {
        options.push({
          text: i,
          value: (i / 100).toFixed(2)
        })
      }

      this.selectedVSABrokerageOptions = options

      return options
    },
    /**
     * After update Leads status need to call fetchSingleQuote
     */
    fnReload() {
      this.fetchQuoteSingle({ quoteType: this.quoteType, id: this.quoteId })
    },
    /**
     * Call Modal which is used to update quote status
     * if quote status in 13 or 14 into 3
     */
    fnCallModalQuoteSubmitConfirm() {
      if (this.vehicle.status == 13 || this.vehicle.status == 14) {
        const childComponent = this.$refs.modalQuoteSubmitConfirm
        if (childComponent) {
          childComponent.fnModalShow()
        }
      }
    }
  },
  async created() {
    await this.fetchFinancierDropdownList()
    await this.fetchReferralPartnerDropdownList('a')
    this.loginUser = authService.getUserFromToken()

    if (this.propsMode == 'new') {
      await this.fetchUserById(this.loginUser.id)

      this.lookupValues.financierId = Number(
        this.getLookupValuesAll?.financierId
      )
    }

    await this.fetchLookupValuesAll()

    if (this.propsMode == 'edit') {
      await this.fnDealerChange(this.vehicle.dealerId)

      await this.fnVSABrokerageOptions(this.lookupValues?.brokerage)
    }
  },
  watch: {
    async propsData(newValue) {
      if (this.propsMode == 'edit') {
        this.vehicle.id = newValue.id
        this.vehicle.clientId = newValue.clientId
        this.vehicle.dealerId = newValue.dealerId
        this.vehicle.referralPartnerId = newValue.referralPartnerId
        this.vehicle.referDealerId = newValue.referDealerId
        this.vehicle.leadSource = newValue.leadSource
        this.leadSource = newValue.leadSource
        this.vehicle.salaryPackagingProviderId =
          newValue.salaryPackagingProviderId
        this.vehicle.salaryPackagingProviderFee =
          newValue.salaryPackagingProviderFee
        this.vehicle.vehicleCondition = newValue.vehicleCondition
        this.vehicle.odometerReading = newValue.odometerReading
        this.vehicle.year = newValue.year
        this.vehicle.make = newValue.make
        this.vehicle.model = newValue.model
        this.vehicle.variant = newValue.variant
        this.vehicle.bodyType = newValue.bodyType
        this.vehicle.vehicleCategoryId = newValue.vehicleCategoryId
        this.vehicle.fuelFlatRate = newValue.fuelFlatRate
        this.vehicle.fuelCostPerKM = newValue.fuelCostPerKM
        this.vehicle.tyresCostPerKM = newValue.tyresCostPerKM
        this.vehicle.serviceCostPerKM = newValue.serviceCostPerKM
        this.vehicle.transmissionId = newValue.transmissionId
        this.vehicle.fuelTypeId = newValue.fuelTypeId
        this.vehicle.colour = newValue.colour
        this.vehicle.accessories = newValue.accessories
        this.vehicle.term = newValue.term
        this.vehicle.rvRate = newValue.rvRate
        this.vehicle.annualKms = newValue.annualKms
        this.vehicle.noFinanceInsurance = newValue.noFinanceInsurance
        this.vehicle.comprehensiveInsurer = newValue.comprehensiveInsurer
        this.vehicle.comprehensiveInsurancePremium =
          newValue.comprehensiveInsurancePremium
        this.vehicle.businessUsePercentage = newValue.businessUsePercentage
        this.vehicle.stampDuty = newValue.stampDuty
        this.vehicle.registration = newValue.registration
        this.vehicle.gstOnAsset = newValue.gstOnAsset
        this.vehicle.gstOnAssetActual = newValue.gstOnAssetActual
        this.vehicle.totalDriveAwayCost = newValue.totalDriveAwayCost
        this.vehicle.chanageBudgetsYesNo = newValue.chanageBudgetsYesNo
        this.vehicle.fuelBudget = newValue.fuelBudget
        this.vehicle.serviceBudget = newValue.serviceBudget
        this.vehicle.tyreBudget = newValue.tyreBudget
        this.vehicle.needToCompeteYesNo = newValue.needToCompeteYesNo
        this.vehicle.dealerBrokerage = newValue.dealerBrokerage
        this.vehicle.status = newValue.status
        this.vehicle.sortOrder = newValue.sortOrder
        this.vehicle.has_messages = newValue.has_messages
        this.vehicle.messages_for_vsa = newValue.messages_for_vsa
        this.vehicle.messages_for_other = newValue.messages_for_other
        this.vehicle.privacyConsent = newValue.privacyConsent
        this.vehicle.settlementDate = newValue.settlementDate
        this.vehicle.fa_no = newValue.fa_no
        this.vehicle.edd = newValue.edd

        Object.assign(this.client, newValue.client)
        Object.assign(this.employment, newValue.client_employment_detail)
        Object.assign(this.finance, newValue.client_finance_detail)
        Object.assign(this.notes, newValue.client_application_notes)
        Object.assign(this.dealerInfo, newValue.dealer)
        Object.assign(this.referralPartnersInfo, newValue.referral_partners)
        Object.assign(this.referDealerInfo, newValue.refer_dealer)
        Object.assign(this.lookupValues, newValue.client_lookup_values)

        await this.fetchUserById(newValue.client.createdBy)
        this.fnCheckIsLocked(newValue.status)
      }
    }
  }
}
</script>
